import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-resource/oss/list?tenantId=' + params.tenantId,
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id, tenantId) => {
  return request({
    url: '/api/blade-resource/oss/detail?tenantId=' + tenantId,
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids, tenantId) => {
  return request({
    url: '/api/blade-resource/oss/remove?tenantId=' + tenantId,
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-resource/oss/submit?tenantId=' + row.tenantId,
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-resource/oss/submit?tenantId=' + row.tenantId,
    method: 'post',
    data: row
  })
}

export const enable = (id, tenantId) => {
  return request({
    url: '/api/blade-resource/oss/enable?tenantId=' + tenantId,
    method: 'post',
    params: {
      id
    }
  })
}
